import { render } from "./HeroiconsSolidDuplicate.vue?vue&type=template&id=40e3566a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDuplicate.vue"]])

export default __exports__